import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

const FloatingButtons = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const isROPage = location.pathname === '/ro';

  const phoneNumber = '+919795200337';
  const whatsappNumber = '919795200337';
  const whatsappMessage = encodeURIComponent('Hello! I would like to know more about your services.');

  const primaryColor = isROPage ? 'blue' : 'green';
  const gradientColor = isROPage 
    ? 'from-blue-500 to-cyan-500 hover:from-blue-600 hover:to-cyan-600' 
    : 'from-green-500 to-cyan-500 hover:from-green-600 hover:to-cyan-600';
  const shadowColor = isROPage ? 'shadow-blue-500/50' : 'shadow-green-500/50';
  const borderColor = isROPage ? 'border-blue-400/50' : 'border-green-400/50';

  const handleCall = () => {
    window.location.href = `tel:${phoneNumber}`;
  };

  const handleWhatsApp = () => {
    window.open(`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`, '_blank');
  };

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-4">
      {/* WhatsApp and Call Buttons */}
      <div className={`flex flex-col gap-3 transition-all duration-300 ${isOpen ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}`}>
        {/* WhatsApp Button */}
        <button
          onClick={handleWhatsApp}
          className={`group relative w-14 h-14 bg-gradient-to-br ${gradientColor} rounded-full ${shadowColor} shadow-xl border-2 ${borderColor} flex items-center justify-center transition-all duration-300 transform hover:scale-110 hover:shadow-2xl`}
          aria-label="WhatsApp"
        >
          <svg className="w-7 h-7 text-white" fill="currentColor" viewBox="0 0 24 24">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.77.966-.94 1.164-.17.199-.34.223-.63.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.67-1.612-.92-2.207-.242-.579-.487-.5-.67-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
          </svg>
          {/* Tooltip */}
          <span className="absolute right-full mr-3 px-3 py-1.5 bg-gray-900 text-white text-sm rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
            WhatsApp
          </span>
        </button>

        {/* Call Button */}
        <button
          onClick={handleCall}
          className={`group relative w-14 h-14 bg-gradient-to-br ${gradientColor} rounded-full ${shadowColor} shadow-xl border-2 ${borderColor} flex items-center justify-center transition-all duration-300 transform hover:scale-110 hover:shadow-2xl`}
          aria-label="Call"
        >
          <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
          </svg>
          {/* Tooltip */}
          <span className="absolute right-full mr-3 px-3 py-1.5 bg-gray-900 text-white text-sm rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
            Call Now
          </span>
        </button>
      </div>

      {/* Main Toggle Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`relative w-16 h-16 bg-gradient-to-br ${gradientColor} rounded-full ${shadowColor} shadow-2xl border-2 ${borderColor} flex items-center justify-center transition-all duration-300 transform hover:scale-110 active:scale-95`}
        aria-label="Quick Contact"
      >
        {isOpen ? (
          <svg className="w-8 h-8 text-white transition-transform duration-300 rotate-45" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        ) : (
          <svg className="w-8 h-8 text-white transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
          </svg>
        )}
        {/* Pulse Animation */}
        <span className={`absolute inset-0 rounded-full bg-gradient-to-br ${gradientColor} animate-ping opacity-20`}></span>
      </button>
    </div>
  );
};

export default FloatingButtons;

